import React from 'react';

import { TableBodyProps, Tbody as ChakraTbody } from '@chakra-ui/react';

export const Tbody = (props: TableBodyProps): React.ReactElement => (
  <ChakraTbody {...props} />
);
